exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".password-panel{margin:auto}.pass-reset{text-align:left}.pass-reset .el-input__inner{width:80%}.password-panel .data{padding-left:40pt!important;text-align:left;background-color:#fff;padding:8pt}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/ChangePassForm.vue"],"names":[],"mappings":"AACA,gBACE,WAAa,CACd,AACD,YACE,eAAiB,CAClB,AACD,6BACE,SAAW,CACZ,AACD,sBACE,4BAA8B,AAC9B,gBAAiB,AACjB,sBAAwB,AACxB,WAAa,CACd","file":"ChangePassForm.vue","sourcesContent":["\n.password-panel {\n  margin: auto;\n}\n.pass-reset {\n  text-align: left;\n}\n.pass-reset .el-input__inner {\n  width: 80%;\n}\n.password-panel .data {\n  padding-left: 40pt !important;\n  text-align: left;\n  background-color: white;\n  padding: 8pt;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d3e3372","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChangePassForm.vue
// module id = 645
// module chunks = 14 16